import React from 'react';
import './ConfirmationView.css';
import { format, parseISO } from 'date-fns';
import PriceBreakdownView from '../RoomDetails/PriceBreakdownView';

const ConfirmationView = ({ selectedRoom, onConfirm, onBack, checkinDate, checkoutDate, guests }) => {
  if (!selectedRoom) {
    return null;
  }

  const { room, rate: selectedRate } = selectedRoom;
  const { name, carousel } = room;
  const { nights_count, total_after_tax } = selectedRate;
  const image = carousel && carousel.length > 0 ? carousel[0] : '';

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return format(parseISO(dateString), 'MMM dd, yyyy');
  };

  const formatGuests = () => {
    if (!guests) return '';
    const { adults, children } = guests;
    const totalGuests = adults + children;
    if (totalGuests === 0) return '';
    if (totalGuests === 1) return '1 Adult';
    if (children === 0) return `${adults} Adults`;
    return `${totalGuests} Guests`;
  };

  const getBreakdownForRate = (rate, room) => {
    if (!rate || !room) return null;

    return {
      roomName: room.room.name,
      rateName: rate.name,
      rateDescription: rate.description,
      nightly: rate.nightly_rates?.map(night => ({
        date: night.date,
        price: night.amount_before_tax
      })) || [],
      taxesAndFees: rate.taxes?.map(tax => ({
        name: tax.description,
        details: tax.details || '',
        amount: tax.amount
      })) || [],
      totalPrice: rate.total_after_tax || 0,
      policies: rate.policies || []
    };
  };

  const breakdownData = getBreakdownForRate(selectedRate, selectedRoom);

  return (
    <div className="confirmation-view">
      <div className="confirmation-header">
        <button className="back-button" onClick={onBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>
        <h1 className="booking-title">Payment & Review</h1>
      </div>
      <div className="confirmation-content">
        <div className="booking-summary-card">
          <img src={image} alt={name} className="summary-room-image" />
          <div className="summary-details-container">
            <h2 className="summary-room-name">{name}</h2>
            <div className="booking-details-list">
              <div className="detail-item">
                <span className="detail-label">Arrive</span>
                <span className="detail-value">{formatDate(checkinDate)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Depart</span>
                <span className="detail-value">{formatDate(checkoutDate)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Nights</span>
                <span className="detail-value">{nights_count}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Guests</span>
                <span className="detail-value">{formatGuests()}</span>
              </div>
            </div>
          </div>
        </div>

        <PriceBreakdownView breakdown={breakdownData} isModal={false} />

      </div>
      <div className="sticky-payment-footer">
        <div className="payment-details">
          <div className="payment-method selected">
            <span className="payment-method-label">Credit Card</span>
            <button className="change-payment">Change</button>
          </div>
        </div>
        <div className="confirmation-footer">
          <div className="footer-price-summary">
            <div className="price-line-1">
              <span className="footer-price-value">${total_after_tax}</span> for {nights_count} night{nights_count !== 1 ? 's' : ''}
            </div>
          </div>
          <button className="confirm-button" onClick={onConfirm}>
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationView; 